<!--The content below is only a placeholder and can be replaced.-->
<div class="wrapper default-theme" [ngClass]="getClasses()">
  <app-navbar></app-navbar>
  <main class="main-content">
    <app-sidebar></app-sidebar>
    <div class="pages container-fluid pt-4 pb-4 pl-4 pr-4">
      <router-outlet></router-outlet>
      <div class="content-push"></div>
    </div>
    <div class="overlay" (onClick)="toggleSidebar()"></div>
  </main>
  <app-footer></app-footer>
</div>
